/* eslint-disable */
import TourProductsRepository from '@/js/common/Domain/Repository/TourProducts';
import tourCriteriaJsonHydrator from '@/js/common/Domain//Hydrator/tourCriteriaJson';
import asyncTourCriteriaJsonHydrator from '@/js/common/Domain//Hydrator/asyncTourCriteriaJson';

import tourCriteriaJsonNewApi from '@/js/common/Domain/Hydrator/tourCriteriaJsonNewApi';

import sessionService from '../session';
import SessionStatusService from '../SessionStatus';
import hotelTourProductsService from '../hotelTourProducts';
import updateData from './services/updateData';

/**
 * This service get tours from server
 *
 * @constructor
 */
const HotelSearch = function () {
    const tourProductsRepository = new TourProductsRepository();
    let startSearchTime = null;
    let firstCacheTime;
    let searchFinishedTime;
    let allAjaxAreCompleted;
    let clearRepositories;
    let clearAllTimeouts;
    let abortAllAjax;
    let ajaxRequests = [];
    let syncAjaxRequests = [];
    let asyncAjaxRequests = [];
    let statusTimeouts = [];
    let globalStatusTimeouts = [];
    let requestTimeouts = [];
    let asyncStatus = { jobsCount: 0, jobsSuccess: 0 };
    let getTourProductsAsync;

    this.getTourProducts = (getToursOptions) => {
        const {
            requests,
            callback,
            additionalParams,
            //searchUuid,
        } = getToursOptions;

        if (!additionalParams || !additionalParams.notClearRepository) {
            this.reset();
        }

        startSearchTime = (new Date()).getTime();
        _.each(requests, (request) => {
            const cacheAjaxData = tourCriteriaJsonNewApi(request.tourCriteria);
            const asyncAjaxData = asyncTourCriteriaJsonHydrator(request.tourCriteria);

            const afterFirstSearchRequest = {
                success: false,
            };
            if (additionalParams && additionalParams.allOperatorsForCache) {
                delete (cacheAjaxData.operators);
            }

            if (request.type === 'sync' || request.type === 'both' || typeof request.type === 'undefined') {
                const finalCallback = () => {
                    if (allAjaxAreCompleted(syncAjaxRequests)) {
                        if (startSearchTime) {
                            searchFinishedTime = (new Date()).getTime();
                        }
                        callback.sync(tourProductsRepository, {
                            startSearchTime,
                            firstCacheTime,
                            searchFinishedTime,
                        });
                    }
                };

                const syncRequest = function () {
                    const XHR = hotelTourProductsService(cacheAjaxData, {
                        success(response) {
                            if (_.isFunction(afterFirstSearchRequest.callback)) {
                                afterFirstSearchRequest.callback();
                                afterFirstSearchRequest.success = true;
                                afterFirstSearchRequest.callback = false;
                            } else {
                                afterFirstSearchRequest.success = true;
                            }

                            updateData({
                                searchData: response.result,
                                tourCriteria: request.tourCriteria,
                                tourProductsRepository,
                            });

                            if (startSearchTime) {
                                if (tourProductsRepository.length) {
                                    firstCacheTime = (new Date()).getTime();
                                }
                                searchFinishedTime = (new Date()).getTime();
                            }
                            finalCallback();
                        },
                        error(XMLHttpRequest, textStatus, errorThrown) {
                            if (errorThrown !== 'abort') {
                                if (_.isFunction(afterFirstSearchRequest.callback)) {
                                    afterFirstSearchRequest.callback();
                                    afterFirstSearchRequest.success = true;
                                    afterFirstSearchRequest.callback = false;
                                } else {
                                    afterFirstSearchRequest.success = true;
                                }
                                if (startSearchTime) {
                                    searchFinishedTime = (new Date()).getTime();
                                }
                                finalCallback();
                            }
                        },
                    });

                    syncAjaxRequests.push(XHR);
                    ajaxRequests.push(XHR);
                };

                if (typeof (request.timeout) !== 'undefined') {
                    requestTimeouts.push(setTimeout(() => {
                        if (_.isEmpty(tourProductsRepository)) {
                            syncRequest();
                        }
                    }, request.timeout));
                } else {
                    syncRequest();
                }
            }

            if (request.type === 'async' || request.type === 'both' || typeof request.type === 'undefined') {
                if (request.type === 'async') {
                    afterFirstSearchRequest.success = true;
                }

                const finalAsyncCallback = () => {
                    if (allAjaxAreCompleted(asyncAjaxRequests)) {
                        if (startSearchTime) {
                            searchFinishedTime = (new Date()).getTime();
                        }

                        callback.async(tourProductsRepository.models, {
                            startSearchTime,
                            firstCacheTime,
                            searchFinishedTime,
                            scannedTours: 0,
                        }, tourProductsRepository);
                    }
                };

                getTourProductsAsync({ cacheAjaxData, asyncAjaxData }, {
                    success(response) {
                        updateData({
                            searchData: response.result,
                            tourCriteria: request.tourCriteria,
                            tourProductsRepository,
                        });

                        finalAsyncCallback();
                    },
                    middleRequest(response) {
                        const updatedTourProducts = updateData({
                            searchData: response.result,
                            tourCriteria: request.tourCriteria,
                            tourProductsRepository,
                        });

                        if (startSearchTime && !firstCacheTime && updatedTourProducts.length) {
                            firstCacheTime = (new Date()).getTime();
                        }

                        if (callback && callback.middleRequest) {
                            callback.middleRequest(updatedTourProducts);
                        }
                    },
                    error(XMLHttpRequest, textStatus, errorThrown) {
                        if (errorThrown !== 'abort') {
                            if (allAjaxAreCompleted(asyncAjaxRequests)) {
                                if (startSearchTime) {
                                    searchFinishedTime = (new Date()).getTime();
                                }
                                callback.async([], {
                                    startSearchTime,
                                    firstCacheTime,
                                    searchFinishedTime,
                                    scannedTours: 0,
                                }, tourProductsRepository);
                            }
                        }
                    },
                }, afterFirstSearchRequest);
            }
        });
    };

    this.getTourProductFromRepository = (tour, roomDescription) => {
        updateData({
            tourProductsData: {
                tours: [tour],
                roomDescriptions: [roomDescription],
            },
            tourProductsRepository,
        });
        return tourProductsRepository;
    };

    this.reset = function () {
        abortAllAjax();
        clearAllTimeouts();
        clearRepositories();
    };
    this.getAsyncStatus = function () {
        return asyncStatus;
    };

    allAjaxAreCompleted = function (requests) {
        let allAreCompleted = true;
        _.each(requests, (request) => {
            if (request.readyState !== 4 && request.readyState !== 0) {
                allAreCompleted = false;
            }
        });
        return allAreCompleted;
    };

    clearRepositories = function () {
        tourProductsRepository.reset();
    };

    const clearRequestTimeouts = function () {
        _.each(requestTimeouts, (requestTimeout) => {
            clearTimeout(requestTimeout);
        });
        requestTimeouts = [];
    };

    clearAllTimeouts = function () {
        _.each(statusTimeouts, (statusTimeout) => {
            clearTimeout(statusTimeout);
        });
        _.each(globalStatusTimeouts, (globalStatusTimeout) => {
            clearTimeout(globalStatusTimeout);
        });
        statusTimeouts = [];
        globalStatusTimeouts = [];

        clearRequestTimeouts();

        startSearchTime = null;
        firstCacheTime = null;
        searchFinishedTime = null;
    };

    abortAllAjax = function () {
        _.each(ajaxRequests, (ajaxRequest) => {
            if (ajaxRequest.readyState !== 4) {
                ajaxRequest.abort();
            }
        });
        ajaxRequests = [];
        syncAjaxRequests = [];
        asyncAjaxRequests = [];
        asyncStatus = { jobsCount: 0, jobsSuccess: 0 };
    };

    getTourProductsAsync = function (tourCriteriaForTourRequest, callback, afterFirstSearchRequest) {
        const sessionXHR = sessionService(tourCriteriaForTourRequest.asyncAjaxData, {
            success(response) {
                const session = response.result ? response.result.id : null;
                const getSessionWrapper = function () {
                    new SessionStatusService(session, {
                        success() {
                            clearRequestTimeouts();
                            const XHR = hotelTourProductsService(tourCriteriaForTourRequest.cacheAjaxData, {
                                success(getTourProductsResponse) {
                                    if (getTourProductsResponse.success === true) {
                                        callback.success(getTourProductsResponse);
                                    } else {
                                        callback.error(null, getTourProductsResponse.message, getTourProductsResponse);
                                    }
                                },
                                error: callback.error,
                            });
                            asyncAjaxRequests.push(XHR);
                            ajaxRequests.push(XHR);
                        },
                        middleRequest() {
                            let XHR;

                            if (callback && callback.middleRequest) {
                                XHR = hotelTourProductsService(tourCriteriaForTourRequest.cacheAjaxData, {
                                    success(response) {
                                        if (response.success === true) {
                                            callback.middleRequest(response);
                                        } else {
                                            callback.middleRequest({
                                                result: [],
                                            });
                                        }
                                    },
                                    error() {
                                        callback.middleRequest({
                                            result: [],
                                        });
                                    },
                                });

                                ajaxRequests.push(XHR);
                            }
                            console.log('send middle request!!');
                        },
                        error(message) {
                            clearRequestTimeouts();
                            callback.error(null, message, response);
                        },
                    }, {
                        asyncAjaxRequests,
                        ajaxRequests,
                        statusTimeouts,
                        globalStatusTimeouts,
                        countryId: tourCriteriaForTourRequest.cacheAjaxData.country,
                        asyncStatus,
                        middleRequestsBehavior: 'halfJobs',
                    });
                };

                if (response.success === true && session) {
                    if (afterFirstSearchRequest.success) {
                        getSessionWrapper();
                    } else {
                        afterFirstSearchRequest.callback = getSessionWrapper;
                    }
                } else {
                    callback.error(null, response.message, response);
                }
            },
            error: callback.error,
        });

        ajaxRequests.push(sessionXHR);
        asyncAjaxRequests.push(sessionXHR);
    };
};

export default HotelSearch;